import { Component } from '@angular/core';

@Component({
  selector: 'app-popup-login',
  templateUrl: './popup-login.component.html',
  styleUrls: ['./popup-login.component.scss'],
})
export class PopupLoginComponent {}
